import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs';

import { TagAdapter } from '../../core/adapters/tag.adapter';
import { setGloballyAvailableTags } from '../../core/store';
import { TagRequester } from '../../requesters';
import { SubscriptionRequester } from '../../requesters/subscription/subscription.requester';
import { DepotAdapter } from '../depot.adapter';
import {
	fetchAvailableSubscriptionsForDepotCreation,
	fetchAvailableSubscriptionsForDepotCreationFailure,
	fetchAvailableSubscriptionsForDepotCreationSuccess,
	initDepotCreation,
} from './depot.actions';

@Injectable()
export class DepotConfigEffects {
	// ##########################################################
	// Navigation Effects
	// ##########################################################

	// ##########################################################
	// Confirmation popup effects
	// ##########################################################

	// ##########################################################
	// Business Effects
	// ##########################################################

	public depotConfigModalInit$ = createEffect(() =>
		this.actions$.pipe(
			ofType(initDepotCreation),
			switchMap(() => this.tagRequester.getAvailableTags(true)),
			map((resp) => this.tagAdapter.generateTags(resp)),
			map((res) =>
				setGloballyAvailableTags({
					availableTags: res,
				})
			)
		)
	);

	public subscriptionsForDepotCreation$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fetchAvailableSubscriptionsForDepotCreation),
			switchMap(() => this.subscriptionRequester.getUsableSubscriptions()),
			map((resp) =>
				this.depotAdapter.generateSubscriptionsListForDepotCreation(resp)
			),
			map((list) =>
				fetchAvailableSubscriptionsForDepotCreationSuccess({
					list,
				})
			),
			catchError((error: HttpErrorResponse, caught) => {
				console.error(error);
				this.store.dispatch(
					fetchAvailableSubscriptionsForDepotCreationFailure({
						error,
					})
				);
				return caught;
			})
		)
	);

	public constructor(
		private readonly actions$: Actions,
		private readonly tagRequester: TagRequester,
		private readonly subscriptionRequester: SubscriptionRequester,
		private readonly depotAdapter: DepotAdapter,
		private readonly tagAdapter: TagAdapter,
		private readonly store: Store
	) {}
}
